import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../locales/en.json";
import mr from "../locales/mr.json";
import hi from "../locales/hi.json";

const saved = localStorage.getItem("app_lang") || "en";

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, mr: { translation: mr }, hi: { translation: hi } },
  lng: saved,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
